import { useState } from 'react';
import store from '../../../_services/store';
import { STORAGE_KEYS } from '../../../constants';
import { setStorageAuthToken } from '../../../_services/utils/token';
import { createUser } from '../../../_services/api/user';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../router/routes';
interface UserRegistration {
  device_id: string;
  professionalid: string;
  civility: string;
  email: string;
  first_name: string;
  last_name: string;
  profession: string;
  password: string;
  laboratory_newsletter: boolean;
  address?: string;
  zipCode?: string;
  city?: string;
  year?: string;
  country_code: string;
  lang_code: string;
}

interface RegisterFormProps {
  onSubmit: (data: UserRegistration) => void;
  isLoading: boolean;
}

interface ProfessionLabels {
  [key: string]: string;
}

const professionLabels: ProfessionLabels = {
  "1": "Medecine interne",
  "2": "Dentiste",
  "3": "Dermatologue",
  "4": "Medecin généraliste",
  "5": "Oncologue",
  "6": "Radiologue",
  "7": "Pharmacien",
  "8": "Assistant médical",
  "9": "Infirmière",
  "10": "Ostéopathe",
  "11": "Podologue",
  "12": "Socio-Esthéticienne"
};

const RegisterForm = ({ onSubmit, isLoading }: RegisterFormProps) => {
  const [formData, setFormData] = useState<UserRegistration>({
    device_id: '', // Vous devrez générer ou obtenir cet ID
    professionalid: '',
    civility: '',
    email: '',
    first_name: '',
    last_name: '',
    profession: '',
    password: '',
    laboratory_newsletter: false,
    address: '',
    zipCode: '',
    city: '',
    year: '',
    country_code: 'fr',
    lang_code: 'fr'
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  return (
    <form onSubmit={handleSubmit} style={{
      maxWidth: '50%',
      margin: '0 auto',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      gap: '20px'
    }} >

      <div>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Civilité
          <select
            name="civility"
            value={formData.civility}
            onChange={handleChange}
            style={{ width: '50%', border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white' }}
            required
          >
            <option value="">Sélectionnez</option>
            <option value="mr">M.</option>
            <option value="mrs">Mme</option>
          </select>
        </label>
      </div>

      <div>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Prénom
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white', width: '-webkit-fill-available' }}
            required
          />
        </label>
      </div>

      <div>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Nom
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white', width: '-webkit-fill-available' }}
            required
          />
        </label>
      </div>

      <div>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Identifiant Pro
          <input
            type="text"
            name="professionalid"
            value={formData.professionalid}
            onChange={handleChange}
            style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white', width: '-webkit-fill-available' }}
            required
            placeholder="Numéro RPPS, etc."
          />
        </label>
      </div>

      <div>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Email
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white', width: '-webkit-fill-available' }}
            required
          />
        </label>
      </div>

      <div>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Mot de passe
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white', width: '-webkit-fill-available' }}
            required
          />
        </label>
      </div>

      <div style={{ maxWidth: '75%' }}>
        <label style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          Profession
          <select
            name="profession"
            value={formData.profession}
            onChange={handleChange}
            style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white' }}
            required
          >
            <option value="">Sélectionnez votre profession</option>
            {Object.entries(professionLabels).map(([value, label]) => (
              <option key={value} value={parseInt(value)}>
                {label}
              </option>
            ))}
          </select>
        </label>
      </div>

      <button
        type="submit"
        style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '5px', backgroundColor: 'white' }}
        disabled={isLoading}
      >
        S'inscrire
      </button>
    </form>
  );
};

export default function RegisterPage() {
  const [isRegistered, setIsRegistered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  
  const handleRegister = async (userData: UserRegistration) => {
    try {
      setIsLoading(true);
      
      const response = await createUser(userData) as User;

      if (!response || !response.auth_token) {
        throw new Error('Erreur lors de l\'inscription');
      }
      
      store.storeProfile({ key: STORAGE_KEYS.user, data: response });
      setStorageAuthToken(response.auth_token);
      store.setAuthToken(response.auth_token);
      setIsRegistered(true);
      setIsLoading(false);
      navigate(ROUTES.HOME());
      // Gérer le succès (redirection, message, etc.)
    } catch (error) {
      // Gérer l'erreur
      setIsError(true);
      setIsLoading(false);
      console.error('Erreur:', error);
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <h1 className="text-3xl font-bold text-center mb-8">Inscription sans PFID</h1>
      <RegisterForm onSubmit={handleRegister} isLoading={isLoading} />
      {isRegistered && <p>Inscription réussie</p>}
      {isLoading && !isError && <p>Inscription en cours...</p>}
      {isError && <p>Erreur lors de l'inscription</p>}
    </div>
  );
}